// src/utils/logger.ts
import log, { LogLevelDesc } from 'loglevel';

// Define the log level type explicitly for clarity
type LogLevel = 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'silent';

// Read the desired log level from environment variables
// Default to 'info' in production, 'debug' in development
const defaultLevel: LogLevel = process.env.NODE_ENV === 'production' ? 'info' : 'debug';
const envLevel = process.env.REACT_APP_LOG_LEVEL as LogLevel | undefined;

// Validate the level from .env, otherwise use the default
const AVAILABLE_LOG_LEVELS = ['trace', 'debug', 'info', 'warn', 'error', 'silent'];
const levelToSet: LogLevelDesc = AVAILABLE_LOG_LEVELS.includes(envLevel ?? '')
  ? envLevel!
  : defaultLevel;
/*
// --- Method Factory for Browser Console Coloring ---
// This overrides the default loglevel behavior to use console methods
// which often have built-in browser coloring.
const originalFactory = log.methodFactory;
log.methodFactory = (methodName, level, loggerName) => {
  const rawMethod = originalFactory(methodName, level, loggerName);

  // Map loglevel levels to console methods
  const consoleMethodMap: { [key in LogLevel]?: keyof Console } = {
    trace: 'debug', // console.trace exists but often includes stack, debug is cleaner
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
  };

  const consoleMethodName = consoleMethodMap[methodName as LogLevel] || 'log'; // Fallback to console.log

  return (...args: any[]) => {
    // You could add prefixes or timestamps here if needed
    // const timestamp = new Date().toISOString();
    // (console as any)[consoleMethodName](`[${timestamp}] [${methodName.toUpperCase()}]`, ...args);

    // Use the corresponding console method dynamically
    // Corrected line:
    (console as any)[consoleMethodName](...args);

    // Optional: Call the original rawMethod if you need loglevel's internal handling too
    // rawMethod(...args);
  };
};
*/

// Set the calculated level for the logger
log.setLevel(levelToSet);

// Log the initial level for confirmation
// Use log.info directly, as methodFactory might not be fully set up for this initial call yet
// depending on internal loglevel implementation details. Using console.info is safer here.
console.info(`Logger for env: ${process.env.NODE_ENV} envLevel: ${process.env.REACT_APP_LOG_LEVEL} initialized with level: ${levelToSet.toUpperCase()}`);

// Export the configured logger instance as default
export default log;
